<template>
  <b-tooltip
    :label="tip"
    :position="position"
    multilined
  >
    <icon-default
      icon="info"
      :size="size"
      color="is-light"
      style="cursor: help"
    ></icon-default>
  </b-tooltip>
</template>

<script>
export default {
  name: "AppInfoTip",
  props: {
    tip: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: 'is-bottom'
    },
    size: {
      type: String,
      default: 'is-small'
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
